import { Middleware } from "redux";
import Smartlook from "smartlook-client";

import { accountApi } from "./account.api";

export const smartlookMiddleware: Middleware = (_store) => (next) => (action) => {
  try {
    if (accountApi.endpoints.getCurrentUser.matchFulfilled(action)) {
      const { id, ...userProps } = action.payload?.user || {};
      if (id) {
        Smartlook.identify(id, userProps);
      }
    }
  } catch (err) {
    console.error("Failed to start smartlook recording", err);
  }

  return next(action);
};
